import styles from "./style.module.scss";
import { ColProps, Row } from "reactstrap";
import DashboardLink from "../DashboardLink";
import cx from "classnames";
import { HTMLAttributeAnchorTarget } from "react";

export type LinkProps = {
  title: string,
  icon: string,
  iconAlt: string,
  url: string,
  target?: HTMLAttributeAnchorTarget | undefined;
  onClick?: () => void;
};

export type DashboardLinksSectionProps = {
  title: string,
  links: LinkProps[],
  isVisible?: boolean

} & ColProps & React.HTMLAttributes<HTMLDivElement>;

const DashboardLinksSection = (props: DashboardLinksSectionProps) => {
  const { title, links, className, isVisible = true, ...rest } = props;

  const renderLinks = (): JSX.Element[] => {
    return links.map((l, index) => {
      return (
        <DashboardLink
          className={styles.secondaryLink}
          linkClassName={styles.secondaryLinkText}
          iconClassName={styles.secondaryLinkIcon}
          key={`link-${index}`}
          sm="4"
          xs="6"
          lg="3"
          target={l.target}
          icon={l.icon}
          iconAlt={l.iconAlt}
          onClick={() => {
            if (l.onClick) {
              l.onClick()
            }
          }}
          to={l.url}
          {...rest}
        >
          {l.title}
        </DashboardLink>
      )
    });
  }

  return isVisible && (
    <div className={cx([styles.section, className])}>
      <h2 className={styles.title}>{title}</h2>
      <Row>
        {renderLinks()}
      </Row>
    </div>

  )
}

export default DashboardLinksSection;